"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var character_list_1 = __importDefault(require("./character-list"));
var icons = character_list_1.default;
module.exports = icons;
exports.default = icons;
